import { spawn } from 'redux-saga/effects';

import { sagas as availableAssetsSagas } from './availableAssetsModule';

export default function* sagas() {
	yield spawn(availableAssetsSagas);
}
